import { useEffect } from "react";
import { Draft, StoredDraft } from "./productRecipeEditor";

export function readRecipeDraft(storageKey: string): StoredDraft | null {
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey) || "null");
    return stored && Array.isArray(stored.draft?.rows) ? stored : null;
  } catch {
    return null;
  }
}
export default function useRecipeDraftRecovery(
  storageKey: string,
  loaded: boolean,
  dirty: boolean,
  version: string | null,
  draft: Draft
) {
  useEffect(() => {
    if (!loaded) return;
    try {
      if (dirty)
        sessionStorage.setItem(storageKey, JSON.stringify({ version, draft }));
      else sessionStorage.removeItem(storageKey);
    } catch {
      // Browser storage is optional; beforeunload still protects unsaved input.
      return;
    }
  }, [loaded, dirty, draft, version, storageKey]);
}
